module.exports = function() {
  return new Worker(__webpack_public_path__ + "8b4f70520b7cdcc89aa0.worker.js");
};